import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import { ReactComponent as SearchIcon } from "../../../../assets/Images/SearchIcon.svg";
import { styled } from "@mui/material/styles";
import { searchBarStyles } from "../../../../assets/MUIStyles/commonStyles";

const SearchBar = ({ searchText, handleChange, styles = {} }) => {
  return (
    <SearchField
      name="search"
      variant="outlined"
      fullWidth
      placeholder="Search"
      value={searchText || ""}
      onChange={handleChange}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="#555555" height={14} width={14} />
            </InputAdornment>
          ),
        },
      }}
      sx={styles}
    />
  );
};

export default SearchBar;

const SearchField = styled(TextField)(() => searchBarStyles);
